import React, { Component } from 'react';
import { Provider } from '../common/ComponentIdContext';
import { ComponentNameProvider } from '../common/ComponentNameContext';
import ConstCommon from '../common/Const';
import ScrollComponent from './../common/ScrollComponent';
import ExpertView from './tab-content/expert-view';
import NewsAggregator from './tab-content/news-aggregator';
import SwitchTab from './common/switch-tab';
import Rumors from './tab-content/rumors';
import TabHeader from './tab-header';
import { REDUCER_NAME, changeTab, setAPIParams } from './reducer';
import AutoNews from './tab-content/auto-news';
import PremiumAnalysis from './tab-content/premium-analysis';
import { connect } from 'react-redux';
import Const from './Const';
import PreRender from './../common/PreRender';
import { compose } from 'redux';

class newsAnalysis extends Component {
  constructor(props) {
    super(props);
    const { changeTab } = this.props;
    if (props.tab) {
      changeTab('currentTab', props.tab);
    }
  }

  handleSwitchTab = (currentTab, type) => {
    const { changeTab } = this.props;
    changeTab(type, currentTab);
  };

  getDefaultSearch = () => {
    const { dragCode } = this.props;
    return dragCode ? dragCode.ticker : '';
  };

  hasSticky = () => {
    return false;
  };

  handleScroll = e => {
    const {
      setAPIParams,
      currentTab,
      currentChildTab,
      contributorsData,
    } = this.props;

    const {
      totalPage,
      apiParams: { Page },
    } = contributorsData;

    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) <=
      e.target.clientHeight;

    let newPage = null;

    if (bottom) {
      if (Page >= totalPage) return;
      newPage = Page + 1;
      setAPIParams(
        { parentTab: currentTab, childTab: currentChildTab },
        { Page: newPage },
      );
    }
  };

  render() {
    const {
      currentTab,
      currentChildTab,
      contributorsData: {
        currentExpert: { expertId },
      },
      id,
    } = this.props;
    console.log(currentTab);
    const defaultSearch = this.getDefaultSearch();

    let optionProps = {};
    if (!expertId) {
      optionProps.appendHandleScroll = this.handleScroll;
    }

    return (
      <PreRender {...this.props}>
        <ComponentNameProvider value={ConstCommon.listComponent.News}>
          <Provider value={id}>
            <ScrollComponent {...optionProps}>
              <div
                className={`d-flex flex-column flex-fill ${
                  this.hasSticky() ? '' : 'min-height-100'
                }`}
              >
                <div className="pt-8 sticky px-20">
                  <SwitchTab
                    handleSwitchTab={this.handleSwitchTab}
                    currentTab={currentTab}
                  />
                </div>
                <div className={`px-20 ${this.hasSticky() ? 'sticky' : ''}`}>
                  <div className="na-top-content">
                    <TabHeader
                      defaultSearch={defaultSearch}
                      currentTab={currentTab}
                      handleSwitchTab={this.handleSwitchTab}
                      currentDataGetFrom={
                        currentTab !== 4
                          ? Const.TAB_MAPPING[currentTab]
                          : Const.TAB_MAPPING[currentTab][currentChildTab]
                      }
                    />
                  </div>
                </div>

                <div className="na-body-content d-flex flex-fill flex-column mb-10">
                  {currentTab === 4 ? (
                    <ExpertView
                      defaultSearch={defaultSearch}
                      currentChildTab={currentChildTab}
                    />
                  ) : (
                    <div className="px-20 d-flex flex-fill flex-column">
                      {currentTab === 1 && (
                        <NewsAggregator defaultSearch={defaultSearch} />
                      )}
                      {currentTab === 2 && (
                        <AutoNews defaultSearch={defaultSearch} />
                      )}
                      {currentTab === 3 && (
                        <PremiumAnalysis defaultSearch={defaultSearch} />
                      )}
                      {currentTab === 5 && (
                        <Rumors defaultSearch={defaultSearch} />
                      )}
                    </div>
                  )}
                </div>
                <div className="na-footer-content" />
              </div>
            </ScrollComponent>
          </Provider>
        </ComponentNameProvider>
      </PreRender>
    );
  }
}

const mapStateToProps = state => ({
  currentTab: state[REDUCER_NAME].currentTab,
  currentChildTab: state[REDUCER_NAME].currentChildTab,
  contributorsData: state[REDUCER_NAME].contributorsData,
});

const mapDispatchToProps = {
  changeTab,
  setAPIParams,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(newsAnalysis);
